export const defaultNoticationsNum = 6;
